/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { EmployeeTerritoriesData, EmployeeTerritoriesService }  from './EmployeeTerritories.service';
import { EmployeesData, EmployeesService } from '../Employees/Employees.service';
import { TerritoriesData, TerritoriesService } from '../Territories/Territories.service';


@Component({
  selector: 'EmployeeTerritoriesSearch',
  template: require('./EmployeeTerritoriesSearch.component.html'),
  providers: [EmployeeTerritoriesService
	, EmployeesService, TerritoriesService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeeTerritoriesSearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objEmployeeTerritories: EmployeeTerritoriesData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	
	EmployeesList: EmployeesData[];
	TerritoriesList: TerritoriesData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private EmployeeTerritoriesService: EmployeeTerritoriesService
			, private  EmployeesService:  EmployeesService
			, private  TerritoriesService:  TerritoriesService

	) {
		// this.id = parseInt(params.get('id'));
		this.objEmployeeTerritories = new EmployeeTerritoriesData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objEmployeeTerritories = new EmployeeTerritoriesData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objEmployeeTerritories.EmployeeID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND EmployeeID = " + this.objEmployeeTerritories.EmployeeID;
			else
				this.filterExpression = "EmployeeID = " + this.objEmployeeTerritories.EmployeeID;
		}
		if (this.objEmployeeTerritories.TerritoryID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND TerritoryID like '%" + this.objEmployeeTerritories.TerritoryID + "%'";
			else
				this.filterExpression = "TerritoryID like '%" + this.objEmployeeTerritories.TerritoryID + "%'";
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}


	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }
	// Get Lookup List for Territories
    getTerritories() {
		this.TerritoriesService.getAll().subscribe(records => this.TerritoriesList=records);
    }

	getLookups() {

        this.getEmployees();
        this.getTerritories();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/EmployeeTerritories/EmployeeTerritoriesSearch.component.ts